(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4255],{

/***/ 78192:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hamesayat",
      function () {
        return __webpack_require__(81525);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/icons/BreadCrumbsIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "4",
        height: "8",
        viewBox: "0 0 4 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 7L0.5 4L3.5 1",
            stroke: "#D5D5D5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var BreadCrumbsIcon = (SvgComponent);

;// CONCATENATED MODULE: ./common/BreadCrumbsData.tsx
var BreadCrumbsData = {
    PrivacyPolicy: {
        links: [
            {
                title: "מדיניות הפרטיות",
                link: "/privacy-policy"
            }, 
        ]
    },
    TermsOfUse: {
        links: [
            {
                title: "תנאי שימוש",
                link: "/terms-of-use"
            }, 
        ]
    },
    Accessibility: {
        links: [
            {
                title: "הצהרת נגישות",
                link: "/accessibility"
            }, 
        ]
    },
    SiteMap: {
        links: [
            {
                title: "מפת אתר",
                link: "/sitemap"
            }
        ]
    },
    Recall: {
        links: [
            {
                title: "קריאות חוזרות",
                link: "/recall"
            }, 
        ]
    },
    Warranty: {
        links: [
            {
                title: "כתב אחריות",
                link: "/warranty"
            }, 
        ]
    },
    ServiceInstructions: {
        links: [
            {
                title: "הוראות שירות",
                link: "/service-instructions"
            }, 
        ]
    },
    WarrantyExtension: {
        links: [
            {
                title: "בדיקת תכולת הארכת אחריות",
                link: "/warranty-extension"
            }
        ]
    },
    SparePriceList: {
        links: [
            {
                title: "מחירון מוצרי תעבורה",
                link: "/spare-price-list"
            }, 
        ]
    },
    ColorCode: {
        links: [
            {
                title: "קוד צבע",
                link: "/color-code"
            }, 
        ]
    },
    Hamesayat: {
        links: [
            {
                title: "המסייעת",
                link: "/hamesayat"
            }, 
        ]
    },
    VideoTutorials: {
        links: [
            {
                title: "סרטוני הדרכה ותפעול",
                link: "/video-tutorials"
            }, 
        ]
    },
    ServicesCenters: {
        links: [
            {
                title: "מרכזי שירות",
                link: "/services-centers"
            }, 
        ]
    },
    ShowRooms: {
        links: [
            {
                title: "אולמות תצוגה",
                link: "/show-rooms"
            }, 
        ]
    },
    CarList: {
        links: [
            {
                title: "מחירון מכוניות",
                link: "/car-list"
            }, 
        ]
    },
    Insurance: {
        links: [
            {
                title: "ביטוח",
                link: "/insurance"
            }, 
        ]
    },
    CarFleets: {
        links: [
            {
                title: "ציי רכב",
                link: "/car-fleets"
            }, 
        ]
    },
    ContactUs: {
        links: [
            {
                title: "צרו קשר",
                link: "/contact-us"
            }, 
        ]
    },
    ServicePlans: {
        links: [
            {
                title: "תוכנית טיפול",
                link: "/service-plans"
            }, 
        ]
    }
};


// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
;// CONCATENATED MODULE: ./common/BreadCrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n  }\n  ",
        " {\n    position: absolute;\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  max-width: 1400px;\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    display: flex;\n    justify-content: flex-start;\n    padding-right: 20px;\n  }\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SINGLE_SERVICE = "singleService";
var CONFIGURATOR = "configurator";
var StyledInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledInnerWrapper",
    componentId: "sc-e82e91a2-0"
})(_templateObject(), function(p) {
    return p.$page === SINGLE_SERVICE && "top: -20px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 25px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "right: 50px;";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "top: -10px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 0px";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledWrapper",
    componentId: "sc-e82e91a2-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== CONFIGURATOR && "width: 100%;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === CONFIGURATOR && "margin-top: -50px";
}, function(p) {
    return p.$page === CONFIGURATOR && (p === null || p === void 0 ? void 0 : p.$pathname) !== constants/* STEPS_EN.summary */.Ws.summary && "margin-right: 50px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "padding-right: 15px;";
}, function(p) {
    return p.$pathname === constants/* STEPS_EN.color */.Ws.color && "padding-right: 16px";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "BreadCrumbs__StyledLink",
    componentId: "sc-e82e91a2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
});
var BreadCrumbsWrapper = function(param) {
    var name = param.name, modelName = param.modelName, id = param.id, page = param.page, pathname = param.pathname;
    var router = (0,client_router.useRouter)();
    var carLinkUrl = function() {
        var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelName));
        return carLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        $page: page,
        $pathname: pathname,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerWrapper, {
            $page: page,
            children: [
                BreadCrumbsData[name] && !modelName && !id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        BreadCrumbsData[name].links.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                color: "inherit",
                                href: item.link,
                                "aria-current": index === BreadCrumbsData[name].links.length - 1 && page !== SINGLE_SERVICE ? "page" : "step",
                                children: item.title
                            }, index);
                        }),
                        page === SINGLE_SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: router.asPath,
                            "aria-current": "page",
                            children: router.query.serviceCenterSlug.toString().replace(/-/g, " ")
                        })
                    ]
                }),
                modelName && id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/models",
                            children: "לכל הדגמים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: carLinkUrl(),
                            "aria-current": page !== CONFIGURATOR ? "page" : "step",
                            children: modelName
                        }),
                        page && page === CONFIGURATOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: router.asPath,
                            "aria-current": "page",
                            children: "התאמה אישית ורכישה"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BreadCrumbs = (BreadCrumbsWrapper);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 24184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PopUp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29525);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55761);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiDialog-paperWidthSm {\n    border-radius: 8px;\n    overflow: hidden;\n    margin: 0 20px;\n  }\n  .MuiBackdrop-root {\n    background: rgba(16, 16, 16, 0.5);\n    webkit-backdropfilter: blur(0px);\n    backdrop-filter: blur(0px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  padding: 0px;\n  color: ",
        ";\n  &:hover {\n    background-color: transparent;\n  }\n  ",
        " {\n    top: 5.25px;\n    right: 15.25px;\n    z-index: 10;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow-y: scroll;\n  padding: 30px !important;\n\n  ",
        " {\n    padding: 20px !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  color: ",
        ";\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 22.4px;\n  ",
        " {\n    font-family: OENaPro;\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 33.6px;\n    letter-spacing: 0.8px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 130%;\n  margin: 0 10px;\n\n  text-align: center;\n\n  color: #616161;\n  margin-top: 15.5px;\n\n  ",
        " {\n    margin: 0 30px;\n    margin-top: 15.5px;\n\n    font-style: normal;\n    font-weight: 300;\n    font-size: 12px;\n    line-height: 130%;\n\n    text-align: center;\n\n    color: #616161;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  color: #999999;\n  background-color: transparent;\n  border: none;\n  font-size: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 130%;\n  margin: 0 10px;\n\n  text-align: center;\n\n  color: ",
        ";\n\n  ",
        " {\n    margin: 0 30px;\n\n    font-style: normal;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 130%;\n\n    text-align: center;\n\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









var StyledDialog = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "PopUp__StyledDialog",
    componentId: "sc-ec9d74b2-0"
})(_templateObject());
var StyledContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "PopUp__StyledContent",
    componentId: "sc-ec9d74b2-1"
})(_templateObject1());
var StyledCloseButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "PopUp__StyledCloseButton",
    componentId: "sc-ec9d74b2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledScrollable = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledScrollable",
    componentId: "sc-ec9d74b2-3"
})(_templateObject3(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledHeaderContainer",
    componentId: "sc-ec9d74b2-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledSubHeaderContainer",
    componentId: "sc-ec9d74b2-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "PopUp__StyledButton",
    componentId: "sc-ec9d74b2-6"
})(_templateObject6());
var StyledDarkSubHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledDarkSubHeaderContainer",
    componentId: "sc-ec9d74b2-7"
})(_templateObject7(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.colors.black;
});
function PopUp(param) {
    var setOpen = param.setOpen, open = param.open, children = param.children, header = param.header, maxWidth = param.maxWidth, width = param.width, customClose = param.customClose, subHeader = param.subHeader, darkSubHeader = param.darkSubHeader;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSubHeaderOpen = ref[0], setIsSubHeaderOpen = ref[1];
    var handleClose = function() {
        customClose ? customClose() : setOpen(false);
    };
    var handleSubClick = function() {
        setIsSubHeaderOpen(!isSubHeaderOpen);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDialog, {
        maxWidth: maxWidth,
        onClose: handleClose,
        "aria-labelledby": "customized-dialog-title",
        open: open,
        style: width ? {
            width: width,
            margin: "auto"
        } : null,
        "aria-modal": "true",
        tabIndex: -1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContent, {
            children: [
                header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeaderContainer, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .TypographyCenter */ .kc, {
                            variant: "h2",
                            $fontSize: "24px",
                            $fontWeight: "400",
                            children: header
                        }),
                        subHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                            onClick: handleSubClick,
                            "aria-expanded": isSubHeaderOpen ? true : false,
                            "aria-label": "מידע נוסף",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                fontSize: "inherit",
                                style: {
                                    color: "#616161",
                                    fill: "#616161"
                                }
                            })
                        })
                    ]
                }),
                darkSubHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDarkSubHeaderContainer, {
                    children: darkSubHeader
                }),
                subHeader && isSubHeaderOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubHeaderContainer, {
                    children: subHeader
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCloseButton, {
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledScrollable, {
                    children: children
                })
            ]
        })
    });
}


/***/ }),

/***/ 97294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ StyledHeaderSubtitle; },
/* harmony export */   "$v": function() { return /* binding */ StyledTh; },
/* harmony export */   "EF": function() { return /* binding */ StyledLi; },
/* harmony export */   "Fg": function() { return /* binding */ StyledLink; },
/* harmony export */   "GI": function() { return /* binding */ StyledTd; },
/* harmony export */   "PW": function() { return /* binding */ StyledSmallText; },
/* harmony export */   "SG": function() { return /* binding */ StyledThead; },
/* harmony export */   "TK": function() { return /* binding */ StyledSubtitle; },
/* harmony export */   "ZN": function() { return /* binding */ StyledBody2; },
/* harmony export */   "aG": function() { return /* binding */ StyledTr; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "hc": function() { return /* binding */ StyledUl; },
/* harmony export */   "k6": function() { return /* binding */ StyledTable; },
/* harmony export */   "vc": function() { return /* binding */ StyledBody; },
/* harmony export */   "x0": function() { return /* binding */ StyledHeaderH2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "px;\n  ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: ",
        "px;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  letter-spacing: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 40px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    max-width: 300px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  &::marker {\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  ",
        ";\n  color: ",
        ";\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-top: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-collapse: collapse;\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    display: block;\n    width: ",
        ";\n    overflow: auto;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: normal;\n  td:first-child {\n    font-size: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 7px 7px;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: normal;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 7px 5px;\n  border: 1px solid ",
        ";\n  font-size: 18px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var StyledHeaderH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "BodyText__StyledHeaderH2",
    componentId: "sc-d1eb1ea9-0"
})(_templateObject(), function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin);
}, function(p) {
    return p.$lineHeight && "line-height: ".concat(p.$lineHeight);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "24px";
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "400";
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSubtitle",
    componentId: "sc-d1eb1ea9-1"
})(_templateObject1(), function(p) {
    return p.$margin;
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "bold";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledHeaderSubtitle",
    componentId: "sc-d1eb1ea9-2"
})(_templateObject2(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "20px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
});
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "BodyText__StyledBody",
    componentId: "sc-d1eb1ea9-3"
})(_templateObject3(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "18px";
});
var StyledH3 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledH3",
    componentId: "sc-d1eb1ea9-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledUl = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "BodyText__StyledUl",
    componentId: "sc-d1eb1ea9-5"
})(_templateObject5(), function(p) {
    return p.$padding && "padding-right: ".concat(p.$padding, "px");
});
var StyledLi = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "BodyText__StyledLi",
    componentId: "sc-d1eb1ea9-6"
})(_templateObject6(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0px";
});
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "BodyText__StyledLink",
    componentId: "sc-d1eb1ea9-7"
})(_templateObject7(), function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
}, function(p) {
    return p.$color ? p.$color : p.theme.colors.mazdaRed;
}, function(p) {
    return p.$display && "display: ".concat(p.$display);
}, function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
});
var StyledSmallText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSmallText",
    componentId: "sc-d1eb1ea9-8"
})(_templateObject8(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$fontWeight && "font-weight: ".concat(p.$fontWeight);
});
var StyledBody2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "BodyText__StyledBody2",
    componentId: "sc-d1eb1ea9-9"
})(_templateObject9(), function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "BodyText__StyledTable",
    componentId: "sc-d1eb1ea9-10"
})(_templateObject10(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$width ? p.$width : "350px";
}, function(p) {
    return p.theme.breakpoints.down("xs");
}, function(p) {
    return p.$width ? p.$width : "90vw";
});
var StyledThead = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].thead.withConfig */ .ZP.thead.withConfig({
    displayName: "BodyText__StyledThead",
    componentId: "sc-d1eb1ea9-11"
})(_templateObject11());
var StyledTr = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
    displayName: "BodyText__StyledTr",
    componentId: "sc-d1eb1ea9-12"
})(_templateObject12(), function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "BodyText__StyledTh",
    componentId: "sc-d1eb1ea9-13"
})(_templateObject13(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTd = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    displayName: "BodyText__StyledTd",
    componentId: "sc-d1eb1ea9-14"
})(_templateObject14(), function(p) {
    return p.theme.colors.darkGrey;
});


/***/ }),

/***/ 86040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ StyledHeaderH1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: ",
        ";\n  margin-top: ",
        ";\n  word-break: ",
        ';\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    text-align: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: 20px;\n  font-weight: 300;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 20px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 27px;\n  color: ',
        ";\n  width: ",
        ";\n  margin: auto;\n  ",
        ";\n  ",
        " {\n    text-align: right;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 0.5px;\n  background-color: ",
        ";\n  margin-top: 40px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledCenterText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledCenterText",
    componentId: "sc-cd579a81-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledHeaderH1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h1"
}).withConfig({
    displayName: "CenterText__StyledHeaderH1",
    componentId: "sc-cd579a81-1"
})(_templateObject1(), function(p) {
    return p.$margin ? "center" : "center";
}, function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0";
}, function(p) {
    return p.$break && p.$break;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$align ? p.$align : "right";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "CenterText__StyledHeaderSubtitle",
    componentId: "sc-cd579a81-2"
})(_templateObject2());
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CenterText__StyledBody",
    componentId: "sc-cd579a81-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.$page === "color" ? "500px" : "985px";
}, function(p) {
    return p.$margin && "margin-top: 20px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLine = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledLine",
    componentId: "sc-cd579a81-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledFooterText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "CenterText__StyledFooterText",
    componentId: "sc-cd579a81-5"
})(_templateObject5());
var CenterText = function(param) {
    var title = param.title, subtitle = param.subtitle, headerText = param.headerText, footerText = param.footerText, withBorder = param.withBorder, margin = param.margin, page = param.page;
    var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCenterText, {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderH1, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderSubtitle, {
                children: subtitle
            }),
            headerText.map(function(text) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBody, {
                    $margin: margin,
                    $page: page,
                    children: text
                }, text);
            }),
            footerText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledFooterText, {
                children: footerText
            }) : null,
            isDesktop && withBorder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLine, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CenterText);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 81525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ hamesayat; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./common/BreadCrumbs.tsx + 2 modules
var BreadCrumbs = __webpack_require__(15738);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./reusable/icons/hamesayat/AppoitmentIcon.tsx





var SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 30;
    var h = 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.75 5H6.25C4.86929 5 3.75 6.11929 3.75 7.5V25C3.75 26.3807 4.86929 27.5 6.25 27.5H23.75C25.1307 27.5 26.25 26.3807 26.25 25V7.5C26.25 6.11929 25.1307 5 23.75 5Z",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.75 12.5H26.25",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 2.5V7.5",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 2.5V7.5",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var AppoitmentIcon = (SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/hamesayat/CarIcon.tsx




var CarIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 30;
    var h = 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 31 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.375 14.0625H28.625",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.75 21.5625V24.375C26.75 24.6236 26.6512 24.8621 26.4754 25.0379C26.2996 25.2137 26.0611 25.3125 25.8125 25.3125H23C22.7514 25.3125 22.5129 25.2137 22.3371 25.0379C22.1613 24.8621 22.0625 24.6236 22.0625 24.375V21.5625",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.9375 21.5625V24.375C8.9375 24.6236 8.83873 24.8621 8.66291 25.0379C8.4871 25.2137 8.24864 25.3125 8 25.3125H5.1875C4.93886 25.3125 4.7004 25.2137 4.52459 25.0379C4.34877 24.8621 4.25 24.6236 4.25 24.375V21.5625",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 17.8125H9.875",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.125 17.8125H23",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.75 14.0625L23.2461 6.1875C23.1734 6.0209 23.0538 5.87903 22.9019 5.77916C22.75 5.67929 22.5724 5.62573 22.3906 5.625H8.60937C8.4276 5.62573 8.24996 5.67929 8.09807 5.77916C7.94619 5.87903 7.82662 6.0209 7.75391 6.1875L4.25 14.0625V21.5625H26.75V14.0625Z",
                stroke: "#101010",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var CarIcon = (CarIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/hamesayat/FaultIcon.tsx





var FaultIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 30;
    var h = 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.8625 4.82452L2.27497 22.4995C2.05668 22.8776 1.94117 23.3061 1.93995 23.7427C1.93873 24.1792 2.05183 24.6084 2.268 24.9877C2.48417 25.3669 2.79587 25.683 3.1721 25.9043C3.54833 26.1257 3.97596 26.2447 4.41247 26.2495H25.5875C26.024 26.2447 26.4516 26.1257 26.8278 25.9043C27.2041 25.683 27.5158 25.3669 27.7319 24.9877C27.9481 24.6084 28.0612 24.1792 28.06 23.7427C28.0588 23.3061 27.9433 22.8776 27.725 22.4995L17.1375 4.82452C16.9146 4.45716 16.6009 4.15342 16.2265 3.94263C15.8521 3.73183 15.4296 3.62109 15 3.62109C14.5703 3.62109 14.1479 3.73183 13.7735 3.94263C13.3991 4.15342 13.0853 4.45716 12.8625 4.82452V4.82452Z",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 11.25V16.25",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 21.25H15.0125",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var FaultIcon = (FaultIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/hamesayat/LocationIcon.tsx





var LocationIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 33;
    var h = 40;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 33 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.7093 29.9546C26.2958 26.1532 29.4974 21.3217 29.4974 16.3952C29.4974 13.0171 28.1609 9.77898 25.7845 7.39278C23.4084 5.00686 20.1875 3.66797 16.8307 3.66797C13.474 3.66797 10.2531 5.00686 7.87696 7.39278C5.50058 9.77898 4.16406 13.0171 4.16406 16.3952C4.16406 21.3217 7.36568 26.1532 10.9521 29.9546C12.705 31.8124 14.4645 33.3346 15.7881 34.3928C16.179 34.7054 16.5304 34.9764 16.8307 35.2025C17.131 34.9764 17.4825 34.7054 17.8734 34.3928C19.1969 33.3346 20.9565 31.8124 22.7093 29.9546ZM16.8307 37.668C16.8307 37.668 31.4974 27.8498 31.4974 16.3952C31.4974 12.4893 29.9522 8.74339 27.2016 5.98149C24.4511 3.21959 20.7206 1.66797 16.8307 1.66797C12.9409 1.66797 9.21036 3.21959 6.45983 5.98149C3.7093 8.74339 2.16406 12.4893 2.16406 16.3952C2.16406 27.8498 16.8307 37.668 16.8307 37.668ZM16.6582 16.3326C16.6304 16.3342 16.5743 16.3375 16.5128 16.2169L16.4953 16.1823C16.3659 15.9258 16.1782 15.5538 15.8411 15.1398C15.5607 14.7943 15.2878 14.5264 14.7651 14.1776C14.2764 13.8518 13.8523 13.6704 13.391 13.4731L13.391 13.4731C13.2368 13.4071 13.0784 13.3394 12.9121 13.2639C12.3899 13.0261 11.943 12.803 11.5051 12.499C11.2742 12.3388 11.0757 12.1675 10.9128 12.009C11.947 9.76651 14.2081 8.21094 16.831 8.21094C19.3526 8.21094 21.5397 9.64861 22.6239 11.7522C22.4265 11.9656 22.135 12.2454 21.7673 12.4995C21.1118 12.9521 20.4682 13.2252 19.8789 13.4752C19.4012 13.6778 18.9592 13.8653 18.5755 14.1211C18.1099 14.4311 17.8331 14.6777 17.5421 15.0254C17.201 15.4328 16.9798 15.798 16.7656 16.2048C16.7195 16.2923 16.6723 16.3267 16.6613 16.3267V16.3324L16.6582 16.3326ZM23.1539 13.1585C23.1323 13.2595 23.0837 13.2925 22.9854 13.3592L22.9854 13.3592L22.9854 13.3592L22.9853 13.3593C22.9578 13.3779 22.9266 13.3992 22.8909 13.4253C22.8359 13.4655 22.7794 13.5073 22.7214 13.5502L22.7213 13.5502L22.7213 13.5503C22.2835 13.8739 21.7641 14.2578 21.2295 14.475C20.8867 14.6142 20.5558 14.7434 20.2678 14.8558L20.2676 14.856L20.2675 14.856L20.2675 14.856L20.2674 14.856L20.2667 14.8563L20.2667 14.8563C20.0462 14.9424 19.851 15.0186 19.6951 15.0819C18.1416 15.7161 17.4659 16.6762 16.9587 17.6664C16.7708 18.034 16.6933 18.1429 16.6697 18.1691L16.6698 18.1739C16.6698 18.1744 16.6697 18.1742 16.6691 18.1727L16.6682 18.1707C16.6634 18.1759 16.6613 18.1769 16.6613 18.1759V18.1541C16.6425 18.1099 16.5846 17.9803 16.4145 17.6473C15.488 15.8398 14.5965 15.4763 13.7587 15.1347L13.7313 15.1236C13.5839 15.0636 13.3843 14.9809 13.1582 14.8872L13.1581 14.8872L13.158 14.8871L13.1579 14.8871C12.8339 14.7529 12.4556 14.5962 12.099 14.4516C11.5306 14.2208 10.8961 13.839 10.4304 13.5106C10.353 13.9139 10.3125 14.3304 10.3125 14.7564C10.3125 18.3713 13.2309 21.3018 16.831 21.3018C20.4311 21.3018 23.3495 18.3713 23.3495 14.7564C23.3495 14.2052 23.2817 13.6699 23.1539 13.1585ZM16.831 23.3018C21.5434 23.3018 25.3495 19.4681 25.3495 14.7564C25.3495 10.0447 21.5434 6.21094 16.831 6.21094C12.1186 6.21094 8.3125 10.0447 8.3125 14.7564C8.3125 19.4681 12.1186 23.3018 16.831 23.3018Z",
            fill: "#101010"
        })
    }));
};
/* harmony default export */ var LocationIcon = (LocationIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/hamesayat/RepairIcon.tsx





var RepairIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 30;
    var h = 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18.3749 7.87565C18.1459 8.10931 18.0176 8.42346 18.0176 8.75065C18.0176 9.07784 18.1459 9.39199 18.3749 9.62565L20.3749 11.6256C20.6086 11.8547 20.9227 11.983 21.2499 11.983C21.5771 11.983 21.8913 11.8547 22.1249 11.6256L26.8374 6.91315C27.466 8.30213 27.6563 9.84969 27.383 11.3496C27.1097 12.8495 26.3858 14.2305 25.3078 15.3085C24.2297 16.3865 22.8488 17.1104 21.3489 17.3837C19.849 17.657 18.3014 17.4667 16.9124 16.8381L8.27494 25.4756C7.77766 25.9729 7.1032 26.2523 6.39994 26.2523C5.69668 26.2523 5.02222 25.9729 4.52494 25.4756C4.02766 24.9784 3.74829 24.3039 3.74829 23.6006C3.74829 22.8974 4.02766 22.2229 4.52494 21.7256L13.1624 13.0881C12.5339 11.6992 12.3436 10.1516 12.6169 8.65172C12.8902 7.15183 13.614 5.77084 14.6921 4.6928C15.7701 3.61476 17.1511 2.89086 18.651 2.61757C20.1509 2.34429 21.6985 2.5346 23.0874 3.16315L18.3874 7.86315L18.3749 7.87565Z",
            stroke: "#020202",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
/* harmony default export */ var RepairIcon = (RepairIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/hamesayat/TimeIcon.tsx





var TimeIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 30;
    var h = 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z",
                stroke: "#020202",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 7.5V15L20 17.5",
                stroke: "#020202",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var TimeIcon = (TimeIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/hamesayat/TowingIcon.tsx




var TowingIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 38;
    var h = 29;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 38 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.4375 3.55078H14.625V15.8008H36.5V24.1133H33",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.125 24.1133L14.625 24.1133",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.75 24.1133H1.5L5.4375 3.55078",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "10.6875",
                cy: "23.6758",
                r: "3.9375",
                stroke: "black",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "29.0625",
                cy: "23.6758",
                r: "3.9375",
                stroke: "black",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 15L22.8333 1H28.3333V6.92308",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.0011 10.6711C26.0041 9.21275 26.5306 6.72374 28.6306 6.72812C30.7306 6.73249 31.2501 9.35858 31.2474 10.6711",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.25 15.8008L15.0625 15.8008",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        ]
    }));
};
/* harmony default export */ var TowingIcon = (TowingIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/hamesayat/WalletIcon.tsx




var WalletIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 32;
    var h = 28;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 32 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M24.3333 6V6C24.3333 3.23858 22.0948 1 19.3333 1H5.71154C3.10943 1 1 3.10943 1 5.71154V6M1 6H31V11.8333M1 6V26.8333H31V20.1667M31 11.8333C28.7778 11.2778 24.3333 11.3333 24.3333 16C24.3333 20.6667 28.7778 20.7222 31 20.1667M31 11.8333V20.1667",
            stroke: "black",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
/* harmony default export */ var WalletIcon = (WalletIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/hamesayat/ZoomInIcon.tsx





var ZoomInIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 30;
    var h = 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.75 23.75C19.2728 23.75 23.75 19.2728 23.75 13.75C23.75 8.22715 19.2728 3.75 13.75 3.75C8.22715 3.75 3.75 8.22715 3.75 13.75C3.75 19.2728 8.22715 23.75 13.75 23.75Z",
                stroke: "#020202",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.25 26.25L20.8125 20.8125",
                stroke: "#020202",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.75 10V17.5",
                stroke: "#020202",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 13.75H17.5",
                stroke: "#020202",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var ZoomInIcon = (ZoomInIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/HamesayatPhoneIcon.tsx

var HamesayatPhoneIcon_SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "27",
        viewBox: "0 0 24 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.33984 13.2506C8.30456 15.4641 9.91548 17.2495 11.9102 18.3157C12.0573 18.3931 12.22 18.4266 12.3824 18.4129C12.5447 18.3992 12.701 18.3388 12.8359 18.2375L15.7656 16.0631C15.8951 15.9655 16.0446 15.906 16.2004 15.8901C16.3561 15.8741 16.513 15.9023 16.6563 15.9719L22.1406 18.5891C22.3281 18.6758 22.4847 18.8285 22.5863 19.0238C22.6879 19.2191 22.729 19.4461 22.7031 19.6698C22.5293 21.1773 21.8671 22.5628 20.8404 23.5669C19.8137 24.5711 18.4928 25.1252 17.125 25.1256C12.8981 25.1256 8.84435 23.2599 5.85549 19.9389C2.86663 16.618 1.1875 12.1138 1.1875 7.41724C1.18781 5.89744 1.6865 4.42984 2.59026 3.28906C3.49403 2.14827 4.74093 1.41246 6.09766 1.21932C6.29903 1.19058 6.50332 1.23619 6.67908 1.34912C6.85483 1.46206 6.9923 1.63605 7.07031 1.84432L9.42578 7.95109C9.48704 8.10779 9.51266 8.27883 9.5004 8.44913C9.48814 8.61943 9.43836 8.78376 9.35547 8.92765L7.39844 12.2349C7.31131 12.3845 7.26017 12.5565 7.24991 12.7343C7.23966 12.9121 7.27062 13.0898 7.33984 13.2506V13.2506Z",
            stroke: "#101010",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var HamesayatPhoneIcon = (HamesayatPhoneIcon_SvgComponent);

// EXTERNAL MODULE: ./reusable/popups/PopUp.tsx
var PopUp = __webpack_require__(24184);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./reusable/wrappers/BodyText.tsx
var BodyText = __webpack_require__(97294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(19393);
;// CONCATENATED MODULE: ./reusable/popups/ModalHeader.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  ",
        " {\n    align-items: center;\n  }\n  ",
        " {\n    align-items: right;\n    p {\n      text-align: right;\n    }\n    h2 {\n      text-align: center;\n    }\n    svg {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0.5px solid ",
        ";\n  margin-top: 40px;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "ModalHeader__StyledWrapper",
    componentId: "sc-52b5138d-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModalHeader__StyledLine",
    componentId: "sc-52b5138d-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.darkGrey;
});
var ModalHeader = function(param) {
    var icon = param.icon, title = param.title, subtitle = param.subtitle;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                $margin: 10,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                style: {
                    width: isDesktop ? "400px" : "216px"
                },
                children: subtitle
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLine, {})
        ]
    });
};
/* harmony default export */ var popups_ModalHeader = (ModalHeader);

;// CONCATENATED MODULE: ./reusable/popups/TowingModal.tsx

function TowingModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  color: ",
        ";\n  display: block;\n  ",
        " {\n    padding-bottom: 20px;\n  }\n"
    ]);
    TowingModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledCaption = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "TowingModal__StyledCaption",
    componentId: "sc-b9cf11e3-0"
})(TowingModal_templateObject(), function(p) {
    return p.theme.colors.mazdaRed;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var TowingModal = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popups_ModalHeader, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TowingIcon, {}),
                title: "גרירה בתשלום",
                subtitle: "גרירה למרכזי השירות המורשים מטעם חברת דלק מוטורס המשתתפים בתוכנית."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledBody */.vc, {
                $margin: 20,
                children: [
                    "א. אם אין שירותי גרירה בפוליסת הביטוח יינתן שירות גרירה חינם",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "זאת במידה והרכב אינו במצב נסיעה."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledBody */.vc, {
                $margin: isDesktop ? 30 : 1,
                children: [
                    "ב. הגרירה תבוצע לאחד ממרכזי השירות המורשים מטעם דלק מוטורס המשתתפים",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    'בתוכנית, עפ"י בחירת בעל הרכב.'
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $margin: isDesktop ? 30 : 1,
                children: "ג.בעת שמרכז השירות סגור וללא שומר, ייגרר הרכב לחניון לילה של חברת שגריר או חברה אחרת ומשם למרכז השירות, עם שובו לפעילות, ללא חיוב הלקוח בעלות גרירה נוספת."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $margin: isDesktop ? 30 : 1,
                children: "ד.אם קיים שירות גרירה בפוליסת הביטוח, מוקד המסייעת יסייע בהפעלתו"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCaption, {
                children: [
                    "*במידה וגרירת הרכב בוצעה שלא באמצעות פוליסת הביטוח של בעל הרכב והרכב לא",
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "תוקן במרכז השירות של דלק מוטורס, יידרש בעל הרכב לשאת בעלות הגרירה."
                ]
            })
        ]
    });
};
/* harmony default export */ var popups_TowingModal = (TowingModal);

;// CONCATENATED MODULE: ./reusable/popups/VehicleModal.tsx





var RepairModal = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popups_ModalHeader, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarIcon, {}),
                title: "העמדת רכב חלופי",
                subtitle: "שירות ללא חיוב"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $margin: isDesktop ? 30 : 20,
                children: "א. הרכב החלופי יסופק לתקופה שאינה עולה על 7 ימים."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $margin: isDesktop ? 30 : 1,
                children: "ב. הרכב החלופי יסופק רק במידה שהתאונה תתוקן במרכז שירות מורשה מטעם חברת דלק מוטורס והמשתתף בתוכנית."
            })
        ]
    });
};
/* harmony default export */ var VehicleModal = (RepairModal);

// EXTERNAL MODULE: ./reusable/wrappers/CenterText.tsx
var CenterText = __webpack_require__(86040);
;// CONCATENATED MODULE: ./reusable/wrappers/IconTextBody.tsx

function IconTextBody_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 40px;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  ",
        " {\n    flex-direction: column;\n    margin-top: 20px;\n  }\n"
    ]);
    IconTextBody_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IconTextBody_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  color: ",
        ";\n  cursor: pointer;\n"
    ]);
    IconTextBody_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 33%;\n  ",
        ";\n  ",
        " {\n    flex-direction: row;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    margin-top: 0px;\n    justify-content: flex-start;\n    svg {\n      margin-top: 10px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  ",
        " {\n    margin-right: 30px;\n    align-items: flex-start;\n  }\n  p {\n    max-width: 200px;\n    ",
        " {\n      max-width: 240px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0.5px solid #999999;\n  width: 100%;\n  margin-top: 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var IconTextBody_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IconTextBody__StyledWrapper",
    componentId: "sc-2a456897-0"
})(IconTextBody_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledPopUpLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IconTextBody__StyledPopUpLink",
    componentId: "sc-2a456897-1"
})(IconTextBody_templateObject1(), function(p) {
    return p.theme.colors.saphire;
});
var StyledIconText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IconTextBody__StyledIconText",
    componentId: "sc-2a456897-2"
})(_templateObject2(), function(p) {
    return p.$margin && "margin-top: 70px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IconTextBody__StyledTextWrapper",
    componentId: "sc-2a456897-3"
})(_templateObject3(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var IconTextBody_StyledLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IconTextBody__StyledLine",
    componentId: "sc-2a456897-4"
})(_templateObject4());
var IconTextBody = function(param) {
    var data = param.data, title = param.title, setModalOpen = param.setModalOpen, setModalType = param.setModalType;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                $margin: 40,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTextBody_StyledWrapper, {
                children: data.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIconText, {
                                $margin: item === null || item === void 0 ? void 0 : item.margin,
                                children: [
                                    item.icon,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderSubtitle */.$L, {
                                                children: item.text
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                                                $margin: !isDesktop && 1,
                                                children: item.subText
                                            }),
                                            (item === null || item === void 0 ? void 0 : item.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                                $color: "#4C607E",
                                                href: "/services-centers",
                                                children: item.link
                                            }),
                                            (item === null || item === void 0 ? void 0 : item.popUp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPopUpLink, {
                                                onClick: function() {
                                                    setModalOpen(true);
                                                    setModalType(item === null || item === void 0 ? void 0 : item.type);
                                                },
                                                children: item.popUp
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTextBody_StyledLine, {})
                        ]
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var wrappers_IconTextBody = (IconTextBody);

// EXTERNAL MODULE: ./reusable/wrappers/ImageContainer.tsx
var ImageContainer = __webpack_require__(63358);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./components/pages/HamesayatPage.tsx

function HamesayatPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  background: ",
        ";\n  padding-bottom: 80px;\n"
    ]);
    HamesayatPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HamesayatPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  max-width: 1400px;\n  text-align: center;\n  width: 100%;\n  ",
        " {\n    padding-right: 20px;\n    padding-left: 20px;\n    text-align: right;\n  }\n"
    ]);
    HamesayatPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HamesayatPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0.5px solid ",
        ";\n  margin-top: 70px;\n"
    ]);
    HamesayatPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HamesayatPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 70px;\n"
    ]);
    HamesayatPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HamesayatPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  text-align: right;\n"
    ]);
    HamesayatPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}























var serviceResponseData = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeIcon, {}),
        text: "מענה טלפוני 24/7",
        subText: "לפניות בנושאים טכניים"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppoitmentIcon, {}),
        text: "סיוע בקביעת תור",
        subText: "למרכז שירות מורשה דלק מוטורס"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamesayatPhoneIcon, {}),
        text: "ליווי טלפוני",
        subText: "עד כניסת הרכב למרכז השירות"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaultIcon, {}),
        text: "תקלה משביתה",
        subText: "סיוע וליווי בהפעלת גרר בהתאם לתנאי פוליסת הביטוח",
        margin: "true"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomInIcon, {}),
        text: "שירותים נוספים",
        subText: "שירות בתשלום עבור דלק / פריצת הרכב / החלפת גלגל",
        margin: "true"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationIcon, {}),
        text: "מרכזי שירות",
        subText: "לרשימה ברחבי הארץ",
        link: "לרשימה מרכזי השירות לחצו כאן",
        margin: "true"
    }, 
];
var assistanceResponseData = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TowingIcon, {}),
        text: "גרירה בחינם",
        subText: "שירותי גרירה",
        popUp: "מידע נוסף",
        type: "towing"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarIcon, {}),
        text: "תיקון מקצועי",
        subText: "תיקונים ע״י מקצוענים ברשת השירות של דלק מוטורס"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RepairIcon, {}),
        text: "העמדת רכב חלופי",
        subText: "שירות ללא חיוב",
        popUp: "מידע נוסף",
        type: "repair"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletIcon, {}),
        text: "השתתפות עצמית",
        subText: "בהתאם לתנאי ההסדר של חברות הביטוח",
        margin: "true"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamesayatPhoneIcon, {}),
        text: "ליווי טלפוני",
        subText: "במהלך כל אירוע",
        margin: "true"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationIcon, {}),
        text: "מרכזי שירות",
        subText: "לרשימה ברחבי הארץ",
        link: "לרשימה מרכזי השירות לחצו כאן",
        margin: "true"
    }, 
];
var StyledPageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HamesayatPage__StyledPageDiv",
    componentId: "sc-53aee9d1-0"
})(HamesayatPage_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var StyledTextWrapp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HamesayatPage__StyledTextWrapp",
    componentId: "sc-53aee9d1-1"
})(HamesayatPage_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var HamesayatPage_StyledLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HamesayatPage__StyledLine",
    componentId: "sc-53aee9d1-2"
})(HamesayatPage_templateObject2(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HamesayatPage__StyledFooter",
    componentId: "sc-53aee9d1-3"
})(HamesayatPage_templateObject3());
var StyledModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HamesayatPage__StyledModalContainer",
    componentId: "sc-53aee9d1-4"
})(HamesayatPage_templateObject4());
var HamesayatPage = function() {
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var ref1 = (0,react.useState)(""), modalType = ref1[0], setModalType = ref1[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var handleModalClose = function() {
        setModalOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledPageWrapper */.S0, {
        $padding: "0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer/* default */.Z, {
                    src: isDesktop ? "/img/hamesayat.jpg" : "/img/hamesayatmobile.jpg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    name: "Hamesayat"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapp, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterText/* StyledHeaderH1 */.O, {
                            children: "המסייעת"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledBody */.vc, {
                            $margin: 20,
                            children: [
                                "בעלי מאזדה נהנים מראש שקט בכל מצב עם מוקד שירות 24/7",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledLink */.Fg, {
                                    $color: "#4C607E",
                                    href: "tel:*2880",
                                    children: [
                                        " ",
                                        "חייגו 2880*",
                                        " "
                                    ]
                                }),
                                " "
                            ]
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(HamesayatPage_StyledLine, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(wrappers_IconTextBody, {
                            data: serviceResponseData,
                            title: "מענה שירותי"
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(HamesayatPage_StyledLine, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(wrappers_IconTextBody, {
                            data: assistanceResponseData,
                            title: "סיוע בעת תאונה",
                            setModalOpen: setModalOpen,
                            setModalType: setModalType
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooter, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody2 */.ZN, {
                                    children: "לפרטים נוספים פנה לאגף השירות"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                    $color: "#4C607E",
                                    href: "tel:08-9139995",
                                    $margin: 10,
                                    children: "08-9139995"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledBody */.vc, {
                                    children: [
                                        "השירות מיועד לרכבים בבעלות פרטית בלבד ובכפוף",
                                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}) : " ",
                                        "לתקנון ״המסייעת״ המצוי במשרדי דלק מוטורס בע״מ"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUp/* default */.Z, {
                    open: modalOpen,
                    setOpen: handleModalClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalContainer, {
                        children: modalType === "repair" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleModal, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(popups_TowingModal, {})
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var pages_HamesayatPage = (HamesayatPage);

;// CONCATENATED MODULE: ./src/pages/hamesayat.tsx



var Hamesayat = function(param) {
    var seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_HamesayatPage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var hamesayat = (Hamesayat);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5716,9774,2888,179], function() { return __webpack_exec__(78192); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);